import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import { environment } from '../../../environments/environment';

type FooterLink = { label: string; href?: string; routerLink?: string };

/**
 * Footer of the signed-out app pages, built to match the footer on
 * bildigsnetz.ch (same box, texts, sizes and logo).
 */
@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NgTemplateOutlet],
})
export class PublicFooterComponent {
  year = new Date().getFullYear();
  baseUrl = environment.homepageBaseUrl;

  platform: FooterLink[] = [
    { label: 'Stellen', routerLink: '/jobs' },
    { label: 'Schulen', routerLink: '/schools' },
    { label: 'Fachkräfte-Netzwerk', routerLink: '/signup' },
    { label: 'Stellenchats', href: this.baseUrl + '/stellenchats' },
    {
      label: "So funktioniert's für Fachkräfte",
      href: this.baseUrl + '/fur-fachkrafte',
    },
    { label: 'Preise', href: this.baseUrl + '/fur-schulen' },
    { label: 'News', href: this.baseUrl + '/news' },
  ];

  columns: { heading: string; links: FooterLink[] }[] = [
    {
      heading: 'Support',
      links: [
        { label: 'Über uns', href: this.baseUrl + '/team' },
        { label: 'Kontakt & Support', href: this.baseUrl + '/kontakt' },
      ],
    },
    {
      heading: 'Rechtliches',
      links: [
        { label: 'Impressum', href: this.baseUrl + '/impressum' },
        { label: 'AGB', href: this.baseUrl + '/agb' },
        { label: 'Datenschutzerklärung', href: this.baseUrl + '/datenschutz' },
      ],
    },
  ];

  social = [
    {
      icon: 'assets/brand/icon-linkedin.svg',
      alt: 'LinkedIn',
      href: 'https://www.linkedin.com/company/bildigsnetz',
    },
    {
      icon: 'assets/brand/icon-instagram.svg',
      alt: 'Instagram',
      href: 'https://www.instagram.com/bildigsnetz',
    },
  ];
}
